import { SaleBidder } from "../bidders/BidderData";
import { LotIndex } from "../lots/LotData";
import { SaleLotCategoryIndex } from "../lots/categories/LotCategoryData";
import { AgTechIndex } from "@agtech/core/utilities/AgTechUtilities";

// Sale Data Features

export const SaleFeatures = {
    EnforceLicensing: 'SalesAppEnforceSaleLicensing'
}

/// Sale Data Entities

export type Sale = {
    id: number,
    saleName: string,
    saleStartDate: Date,
    saleEndDate: Date
}

export const DefaultSale = {
    id: 0,
    saleName: '',
    saleStartDate: new Date(),
    saleEndDate: new Date()
}

export type SaleData = {
    sale: Sale,
    bidders: AgTechIndex<SaleBidder>,
    lots: LotIndex,
    lotCategories: SaleLotCategoryIndex
}